<template>
  <div>
    <a-drawer :title="`${actType}标题`" :width="720" :visible="titleForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form" :model="model" :rules="rules">

        <a-form-model-item label="标题组名称" prop="title_group_name">
          <a-input v-model="model.title_group_name" :disabled="true"/>
        </a-form-model-item>

        <a-form-model-item label="标题" prop="name" v-if="model.id">
          <a-input v-model="model.name" placeholder="请填写标题" />
        </a-form-model-item>

        <a-form-model-item label="标题" prop="titles" v-else>
          <a-textarea v-model="titles" placeholder="请填写标题" :auto-size="{ minRows: 15 }" />
        </a-form-model-item>

      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'Title';
</style>

<script>
import Title from './Title'

export default Title
</script>
